
/**
 * Set environment
 * @returns {boolean}
 */

 /** Development Mode */

 function isDev()
 {
     /** Return true if active development */

     return true;
 }

/** Testing Mode */

  function isTest()
 {
     /** Return true if active testing */

     return false;
 }

/** Production Mode */

  function isProd()
 {
     /** Return true if active production */

     return false;
 }

/** Exports and Conditions are added here */
/** Development */

export let SERVER_URL = isDev() ? "http://localhost:3000" : "https://logit-api.consultaegis.com";
export let ISDEV = isDev() ? true : false;

/** Testing */

// export let SERVER_URL = isTest() ? "http://localhost:3000" : "https://logit-api.consultaegis.com";
export let ISTEST = isTest() ? true : false;

/** Production */

// export let SERVER_URL = isProd() ? "http://localhost:3000" : "https://logit-api.consultaegis.com";
export let ISPROD = isProd() ? true : false;


/** Instructions
*
* 1. Add the following import
* import { ISDEV } from "../../services/config";
*
* 2. Add the following inside Export Wrapper
* public isDev = ISDEV;
*
* 3. Add the following wrapper to any development only code or logs
* if(this.isDev == true) { dev code goes here }
*
*/



/********************************************************************/


/** Support Modal */

//export let SUPPORT_ONE = isSupportOne() ? true : false;
export let SUPPORT_ONE = "activitylisthelp.png";
export let SUPPORT_TWO = 'loghelpguide.png';

export let APP_TITLE = 'LogIt';



// WEBPACK FOOTER //
// ./src/services/config.ts